import Dispatcher from "Dispatcher";
import TreeItemTypes from "./TreeItemTypes.js";

const TreeItemActions = {
    collapseAll(ctx) {
        Dispatcher.contextDispatch(ctx, {
            type: TreeItemTypes.COLLAPSE_ALL
        });
    },

    expandAll(ctx) {
        Dispatcher.contextDispatch(ctx, {
            type: TreeItemTypes.EXPAND_ALL
        });
    },

    childCollapseOrExpand(ctx, key) {
        Dispatcher.contextDispatch(ctx, {
            type: TreeItemTypes.COLLAPSE_OR_EXPAND,
            key,
        });
    }
};

export default TreeItemActions;



// WEBPACK FOOTER //
// ./app/data/TreeItemActions.js